import { API_BASE_URL } from './api';

export const loginUser = async (email, password) => {
  const response = await fetch(`${API_BASE_URL}/users/sign_in`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ user: { email, password } }),
  });

  if (!response.ok) throw new Error('Login failed');
  return await response.json();
};

export const passwordResetRequest = async (email) => {
  const response = await fetch(`${API_BASE_URL}/users/password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ user: { email } }),
  });

  if (!response.ok) throw new Error('Password reset request failed');
  return await response.json();
};

export const logoutUser = async (token) => {
  return await fetch(`${API_BASE_URL}/users/sign_out`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    credentials: 'include',
  });
};

export const registerUser = async (name, email, password) => {
  const response = await fetch(`${API_BASE_URL}/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ user: { name, email, password } }),
  });

  if (!response.ok) throw new Error('Registration failed');
  return await response.json();
};

export const verifyUserToken = async (token) => {
  const response = await fetch(`${API_BASE_URL}/users/verify_token`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  });

  if (!response.ok) throw new Error('Token verification failed');
  return await response.json();
};

export const initiateGoogleLogin = () => {
  window.location.href = `${API_BASE_URL}/users/auth/google_oauth2`;
}; 